@if (!internetAvailable) {
  <ion-fab vertical="bottom" horizontal="end" position="fixed" color="fri-violet">
    <ion-icon name="wifi-outline"></ion-icon>
  </ion-fab>
}
